import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safe',
  standalone: false,
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): any {
    let corretUrl = '';
    if (url.includes('www.youtube.com/watch')) {
      let ulrs = url.split('=')[1];
      let urlId = ulrs.split('&');
      corretUrl = `https://youtube.com/embed/${urlId[0]}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(corretUrl);
    } else if (url.includes('youtu.be')) {
      let urls = url.split('/');
      corretUrl = `https://youtube.com/embed/${urls[3]}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(corretUrl);
    } else if (url.includes('/shorts')) {
      let urls = url.split('/shorts');
      corretUrl = `https://youtube.com/embed/${urls[1].split('/')[1]}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(corretUrl);
    }
  }
}
